/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';
import {
  SearchFacetsResponseBuckets,
  SearchStateExtendsType,
  SearchStateFilterObj,
  SearchFacetsResponse,
} from '../../organisms/OSearchResults/store/store.type';
import {
  SearchFacetsList,
  ALL_INCLUSIVE_LABEL,
  ALL_INCLUSIVE_CODE,
  SearchFacetsListCodes,
} from '../../organisms/OSearchResults/index.constant';
import {
  StyledOCheckboxItemDiv as StyledCheckboxItemDiv,
  StyledOCheckboxItemsContainer as StyledCheckboxItemsContainer,
} from '../../organisms/OSearchResults/index.styles';
import { StyledHotelTypeFilterDiv } from './index.styles';
import { useWindowSize } from '../..//hooks';
import { BREAKPOINT_DESKTOP_1023, BREAKPOINT_TABLET } from '../../organisms/OSearchResults/lib/application.constants';
import { renderedData } from '../../organisms/OSearchResults/searchResultsMainComponent';
import { formatNumberByLocale } from '../../utils';
import { useConditionalSessionUpdateContext } from '../../hooks';
import { useConditionalPageContextSERP } from '../../hooks';
import { useConditionalSearchResultsRenderedDataSERP } from '../../hooks/lib/useConditionalRenderedData';
import { CheckBox, checkboxVariation } from '@marriott/mi-ui-library';
import { useConditionalSearchFilterContextWithSerpFlag } from '../../hooks/lib/useConditionalSearchFilterContext';
declare module 'react' {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  interface HTMLAttributes<T> {
    custom_click_track_value?: string;
  }
}

export const HotelTypeFilterComponent: React.FC<{
  onItemSelect: (arg: SearchFacetsList, arg2: SearchStateFilterObj) => void;
  clearFilterState: SearchStateExtendsType | undefined | null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  hotelTypeList?: any;
}> = ({ onItemSelect, clearFilterState, hotelTypeList }) => {
  const { searchQueryState } = useConditionalSearchFilterContextWithSerpFlag();
  const { currentLocale } = useConditionalPageContextSERP();
  const { jsonContent }: any = useConditionalSearchResultsRenderedDataSERP(renderedData);
  const { interactionsSelected, setInteractionsSelected } = useConditionalSessionUpdateContext();
  const clickTrackingLoc = 'Phoenix Search Results';
  const { width } = useWindowSize();

  const [currSelectedItem, setCurrSelectedItem] = useState<SearchStateFilterObj | undefined>(
    searchQueryState[SearchFacetsList.propertyType]
  );

  const getCurrHotelTypes = (): SearchFacetsResponse =>
    hotelTypeList
      ? hotelTypeList
      : // eslint-disable-next-line @typescript-eslint/no-explicit-any
        searchQueryState?.filter?.filter((key: any) => key.type.code === SearchFacetsListCodes?.propertyType)[0];

  const [hotelTypes, setHotelTypes] = useState<SearchFacetsResponse>(getCurrHotelTypes());

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const onSelectFilter = (event: any, data: SearchFacetsResponseBuckets): void => {
    if (event.key === 'Enter' || event.type === 'click' || event.type === 'change' || event.keyCode === 13) {
      let obj: SearchStateFilterObj | undefined = { ...currSelectedItem };
      if (obj !== undefined) {
        if (data.code in obj) {
          delete obj[data.code];
        } else {
          obj[data.code] = data.code;
        }
      } else {
        obj = {};
        obj[data.code] = data.code;
      }
      setCurrSelectedItem(obj);
      if (onItemSelect) {
        onItemSelect(SearchFacetsList.propertyType, obj);
      }
    }
    setInteractionsSelected({ ...interactionsSelected, hotelType: true });
  };

  useEffect(() => {
    if (clearFilterState === undefined || clearFilterState === null) {
      setCurrSelectedItem(undefined);
    }
  }, [clearFilterState]);

  useEffect(() => {
    setHotelTypes(getCurrHotelTypes());
  }, [hotelTypeList]);

  return hotelTypes?.type?.count ? (
    <StyledHotelTypeFilterDiv className="t-font-alt-m hotel-types-filters-container">
      <fieldset>
        <div className="t-font-alt-m filter-heading-container">
          <legend>
            <h4
              className={
                (width && width > BREAKPOINT_DESKTOP_1023
                  ? `t-subtitle-l`
                  : width && width > BREAKPOINT_TABLET
                  ? `t-subtitle-l`
                  : `t-subtitle-m`) + ' filter-heading'
              }
            >
              {jsonContent?.hotelTypeLabel}
            </h4>
          </legend>
        </div>
      </fieldset>
      <StyledCheckboxItemsContainer>
        {hotelTypes?.buckets?.map((hotelType: SearchFacetsResponseBuckets, idx: number) => (
          <StyledCheckboxItemDiv className="m-checkbox-selection-item hotel-type-description" key={idx}>
            <CheckBox
              variation={checkboxVariation.SIMPLE}
              className=""
              checkboxId={`hotel-types-${hotelType?.code}-checkbox`}
              checkboxName="hotel_type_filter_checkbox"
              onChange={(e): void => onSelectFilter(e, hotelType)}
              onKeyDown={(e): void => onSelectFilter(e, hotelType)}
              checked={currSelectedItem ? hotelType.code in currSelectedItem === true : false}
              inputClassName="checkbox-input custom_click_track"
              setTabIndex={-1}
              children={
                <>
                  <span className="t-font-s">
                    {hotelType?.code === ALL_INCLUSIVE_CODE ? ALL_INCLUSIVE_LABEL : hotelType?.label}
                  </span>
                  {hotelType?.count && (
                    <span className="t-font-s pl-1">({formatNumberByLocale(hotelType?.count, currentLocale)})</span>
                  )}
                </>
              }
              {...{
                custom_click_track_value: `${clickTrackingLoc}| Hotel Type options:${hotelType?.label} |internal`,
              }}
            />
          </StyledCheckboxItemDiv>
        ))}
      </StyledCheckboxItemsContainer>
      <hr aria-hidden className="filter-separator" />
    </StyledHotelTypeFilterDiv>
  ) : null;
};
